/**
 * Gift Wrapping - Product Add to Cart JavaScript
 * Works with xo-cart-add web component
 * Features: Drawer UI, Recipient fields, Cart refresh, Flow triggers
 */

(function() {
  'use strict';

  console.log('[Gift Wrapping] Script loaded');

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftWrapping);
  } else {
    initGiftWrapping();
  }

  function initGiftWrapping() {
    console.log('[Gift Wrapping] Initializing...');
    
    const giftContainer = document.querySelector('[data-gift-wrapping]');
    const giftCheckbox = document.querySelector('#add_gift_wrapping');
    const xoCartAdd = document.querySelector('xo-cart-add');
    const productForm = document.querySelector('form[xo-buy-ignore]');
    const drawer = document.querySelector('#gift_wrapping_drawer');
    const drawerOverlay = document.querySelector('#gift_drawer_overlay');
    const drawerClose = document.querySelector('#gift_drawer_close');
    const drawerApply = document.querySelector('#gift_drawer_apply');
    const wrappingInner = document.querySelector('.product__wrapping-inner');
    
    console.log('[Gift Wrapping] Elements found:', {
      container: !!giftContainer,
      checkbox: !!giftCheckbox,
      xoCartAdd: !!xoCartAdd,
      form: !!productForm,
      drawer: !!drawer,
      wrappingInner: !!wrappingInner
    });

    if (!giftContainer) {
      console.error('[Gift Wrapping] Gift wrapping container not found');
      return;
    }

    if (!xoCartAdd || !productForm) {
      console.error('[Gift Wrapping] Missing xo-cart-add or form');
      return;
    }

    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    // Initialize drawer functionality
    setupDrawerHandlers(drawer, drawerOverlay, drawerClose, drawerApply, wrappingInner, giftContainer);

    // Setup checkbox listener
    giftCheckbox.addEventListener('change', function() {
      console.log('[Gift Wrapping] Checkbox state:', this.checked);
    });

    // Setup cart add listener
    document.addEventListener('click', function(e) {
      const clickTarget = e.target.closest('xo-cart-add');
      
      if (!clickTarget) {
        return;
      }

      console.log('[Gift Wrapping] ===== xo-cart-add CLICKED =====');
      console.log('[Gift Wrapping] Checkbox checked:', giftCheckbox.checked);

      if (!giftCheckbox.checked) {
        console.log('[Gift Wrapping] Gift wrapping NOT selected - normal flow');
        return;
      }

      console.log('[Gift Wrapping] Gift wrapping IS selected - adding gift product');
      
      // Wait for main product to be added, then add gift product
      setTimeout(() => {
        console.log('[Gift Wrapping] Adding gift product to cart...');
        const drawer = document.querySelector('#gift_wrapping_drawer');
        console.log('[Gift Wrapping] Drawer found:', !!drawer);
        if (drawer) {
          addGiftProductToCart(giftContainer, productForm, drawer);
        } else {
          console.error('[Gift Wrapping] ❌ Drawer not found when trying to add gift product');
        }
      }, 800);
    }, true);

    console.log('[Gift Wrapping] Initialization complete');
  }

  function setupDrawerHandlers(drawer, overlay, closeBtn, applyBtn, wrappingInner, giftContainer) {
    if (!drawer) {
      console.warn('[Gift Wrapping] Drawer not found - skipping drawer setup');
      return;
    }

    const giftCheckbox = document.querySelector('#add_gift_wrapping');

    // Open drawer when checkbox is checked
    giftCheckbox.addEventListener('change', function(e) {
      if (this.checked) {
        console.log('[Gift Wrapping] Checkbox checked - opening drawer');
        openDrawer(drawer);
      } else {
        console.log('[Gift Wrapping] Checkbox unchecked - closing drawer');
        closeDrawer(drawer);
      }
    });

    // Close drawer
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      giftCheckbox.checked = false;
      closeDrawer(drawer);
    });

    overlay.addEventListener('click', function() {
      giftCheckbox.checked = false;
      closeDrawer(drawer);
    });

    // Apply button - close drawer after confirming selection
    applyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('[Gift Wrapping] Gift fields applied from drawer');
      // Keep checkbox checked but close drawer
      closeDrawer(drawer);
    });

    // Sync on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('active')) {
        giftCheckbox.checked = false;
        closeDrawer(drawer);
      }
    });
  }

  function openDrawer(drawer) {
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function moveGiftModalToBody(drawer) {
    if (!drawer) return;
    if (drawer.parentElement === document.body) return;
    document.body.appendChild(drawer);
  }

  function syncFieldsToDrawer(giftContainer, drawer) {
    // No longer needed - all fields are only in drawer
  }

  function syncFieldsFromDrawer(giftContainer, drawer) {
    // No longer needed - all fields are only in drawer
  }

  function updateCharacterCount(textarea) {
    if (!textarea) return;
    const counter = textarea.closest('.product__wrapping-field')?.querySelector('.counter-current');
    if (counter) {
      counter.textContent = textarea.value.length;
    }
  }

  function addGiftProductToCart(giftContainer, form, drawer) {
    console.log('[Gift Wrapping] ===== ADDING GIFT PRODUCT =====');
    console.log('[Gift Wrapping] Drawer present:', !!drawer);
    console.log('[Gift Wrapping] GiftContainer present:', !!giftContainer);
    
    const giftId = giftContainer.dataset.giftId;
    const productId = giftContainer.dataset.giftProduct;
    
    console.log('[Gift Wrapping] giftId:', giftId);
    console.log('[Gift Wrapping] productId:', productId);
    
    // Get values from drawer (only source of truth now)
    const drawerRecipientInput = drawer.querySelector('#drawer_gift_recipient_name');
    const drawerGreetingInput = drawer.querySelector('#drawer_gift_greeting');
    const drawerMessageInput = drawer.querySelector('#drawer_gift_message');

    console.log('[Gift Wrapping] Drawer inputs found:', {
      recipient: !!drawerRecipientInput,
      greeting: !!drawerGreetingInput,
      message: !!drawerMessageInput
    });

    const recipientName = drawerRecipientInput?.value || '';
    const greeting = drawerGreetingInput?.value || '';
    const message = drawerMessageInput?.value || '';

    console.log('[Gift Wrapping] Collected data:', {
      giftId,
      productId,
      recipientName,
      greeting,
      message: message.substring(0, 50)
    });

    // Validate
    if (!giftId || giftId === 'undefined' || giftId === '') {
      console.error('[Gift Wrapping] ❌ giftId is empty!');
      alert('Gift product is not configured. Please contact support.');
      return;
    }

    if (!productId || productId === 'undefined' || productId === '') {
      console.error('[Gift Wrapping] ❌ productId is empty!');
      return;
    }

    console.log('[Gift Wrapping] ✓ Validation passed');

    // Prepare cart payload with all gift fields
    const giftPayload = {
      items: [{
        id: parseInt(giftId),
        quantity: 1,
        properties: {
          '_gift_wrapping_message': message,
          '_gift_recipient_name': recipientName,
          '_gift_greeting': greeting,
          '_gift_wrapping_for': productId
        }
      }]
    };

    console.log('[Gift Wrapping] Payload:', JSON.stringify(giftPayload));
    console.log('[Gift Wrapping] Cart URL:', window.routes.cart_add_url + '.js');

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(giftPayload)
    })
    .then(response => {
      console.log('[Gift Wrapping] Response status:', response.status);
      if (!response.ok) {
        return response.text().then(text => {
          console.error('[Gift Wrapping] ❌ Error:', response.status, text);
          throw new Error(`HTTP ${response.status}`);
        });
      }
      return response.json();
    })
    .then(data => {
      console.log('[Gift Wrapping] ✓ Gift product added successfully');
      console.log('[Gift Wrapping] Cart data:', {
        itemCount: data.item_count,
        itemsCount: data.items.length
      });
      
      // Refresh cart via AJAX
      triggerCartRefresh();
      
      // Also trigger flow event
      triggerGiftWrappingFlow(data, giftPayload.items[0].properties);
      
      // Setup a watcher to auto-try refresh if UI doesn't update
      setupCartWatcher();
    })
    .catch(error => {
      console.error('[Gift Wrapping] ❌ Fetch error:', error.message);
    });
  }

  function triggerCartRefresh() {
    console.log('[Gift Wrapping] Triggering cart refresh...');
    
    // Approach: Fetch fresh cart page and extract the cart modal HTML, then update DOM
    // This ensures we get server-rendered HTML with updated cart items
    
    const currentUrl = new URL(window.location.href);
    
    // Fetch the page without section_id (to get full HTML with cart modal)
    fetch(currentUrl.toString(), {
      headers: {
        'Accept': 'text/html'
      }
    })
    .then(response => response.text())
    .then(html => {
      console.log('[Gift Wrapping] Fetched fresh page HTML');
      
      // Parse response
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');
      
      // Find cart-related elements in the fresh response
      const newCartMini = newDoc.querySelector('xo-cart-mini');
      const currentCartMini = document.querySelector('xo-cart-mini');
      
      // Find xo-cart-will-change elements (the actual content sections)
      const newCartWillChange = newDoc.querySelectorAll('xo-cart-will-change');
      const currentCartWillChange = document.querySelectorAll('xo-cart-will-change');
      
      console.log('[Gift Wrapping] Found xo-cart-will-change:', {
        fresh: newCartWillChange.length,
        current: currentCartWillChange.length
      });
      
      // Update each xo-cart-will-change section with fresh HTML
      currentCartWillChange.forEach((element, index) => {
        if (newCartWillChange[index]) {
          const freshHTML = newCartWillChange[index].innerHTML;
          if (element.innerHTML !== freshHTML) {
            console.log('[Gift Wrapping] Updating cart section', index);
            element.innerHTML = freshHTML;
            
            // Try to trigger re-render if method exists
            if (typeof element.requestUpdate === 'function') {
              element.requestUpdate();
            }
          }
        }
      });
      
      // Also try to find and update xo-cart-mini
      if (currentCartMini && newCartMini && currentCartMini.innerHTML !== newCartMini.innerHTML) {
        console.log('[Gift Wrapping] Updating xo-cart-mini content');
        
        // Update the innerHTML
        currentCartMini.innerHTML = newCartMini.innerHTML;
        
        // Try to trigger lifecycle
        if (typeof currentCartMini.requestUpdate === 'function') {
          currentCartMini.requestUpdate();
        }
      }
      
      // Find and update xo-cart-size elements (the item count badge)
      const newCartSizes = newDoc.querySelectorAll('xo-cart-size');
      const currentCartSizes = document.querySelectorAll('xo-cart-size');
      
      currentCartSizes.forEach((element, index) => {
        if (newCartSizes[index] && element.textContent !== newCartSizes[index].textContent) {
          console.log('[Gift Wrapping] Updating cart size', index);
          element.textContent = newCartSizes[index].textContent;
        }
      });
      
      console.log('[Gift Wrapping] ✓ Cart refresh complete');
    })
    .catch(error => {
      console.error('[Gift Wrapping] Error refreshing cart:', error);
    });
  }

  function setupCartWatcher() {
    console.log('[Gift Wrapping] Setting up cart watcher...');
    
    // Target the actual cart modals and sticky cart
    const cartModals = document.querySelectorAll('.xo-modal-content__content--cart-modal');
    const stickyCart = document.querySelector('.xo-sticky-cart');
    
    let elementsToWatch = [];
    
    if (cartModals.length > 0) {
      console.log('[Gift Wrapping] Found', cartModals.length, 'cart modals to watch');
      elementsToWatch = Array.from(cartModals);
    }
    
    if (stickyCart) {
      console.log('[Gift Wrapping] Found sticky cart to watch');
      elementsToWatch.push(stickyCart);
    }
    
    if (elementsToWatch.length === 0) {
      console.log('[Gift Wrapping] ⚠️ No specific cart elements found');
      return;
    }
    
    // Watch for content changes in these elements
    elementsToWatch.forEach((element, index) => {
      console.log('[Gift Wrapping] Watching cart element', index);
      
      const observer = new MutationObserver((mutations) => {
        console.log('[Gift Wrapping] Cart element mutation detected on element', index);
      });
      
      observer.observe(element, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  function triggerGiftWrappingFlow(cartData, properties) {
    console.log('[Gift Wrapping] Triggering gift wrapping flow event...');
    
    // Dispatch custom event that can be caught by flow triggers or custom JS
    const flowEvent = new CustomEvent('giftWrappingAdded', {
      detail: {
        cartData: cartData,
        giftProperties: properties,
        timestamp: new Date().toISOString()
      }
    });
    
    document.dispatchEvent(flowEvent);
    window.dispatchEvent(flowEvent);
    
    console.log('[Gift Wrapping] ✓ Flow event dispatched');
  }

  // Character counter functionality
  document.addEventListener('input', function(e) {
    if (e.target.classList.contains('product__wrapping-textarea')) {
      updateCharacterCount(e.target);
    }
  });
})();

